'use client';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { Breadcrumbs } from '../../components/homepage/breadcrumbs';
import { Heading } from '../../components/ui/heading';
import { ComparisonProducts } from '../../components/product/comparison/comparison-products';

export default function Page() {
  return (
    <section
      className={cn(
        'custom-section',
        'pb-12 pr-0 pt-12 sm:pb-16 md:pb-20 lg:pb-24 xl:pr-5',
        'section-gap',
      )}
    >
      <div className={cn('custom-container', 'flex flex-col items-center justify-center gap-4')}>
        <Breadcrumbs
          breadcrumb={{ name: 'Porovnanie produktov', slug: ROUTES.PRODUCT_COMPARISON() }}
          className={{
            wrapper: 'w-full items-center justify-center',
            list: 'w-full items-center justify-center',
          }}
        />
        <Heading tag="h1" styleAs="h2" center title={'Porovnanie produktov'} />
      </div>
      <ComparisonProducts />
    </section>
  );
}
